import React__default from 'react';

const width = 20;
const height = 20;
const IconSearch = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14ZM19.998 18.584L14.312 12.897C15.365 11.543 16 9.846 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C9.846 16 11.543 15.365 12.897 14.312L18.584 19.998L19.998 18.584Z", fill: fill })));
};

export { IconSearch as default };
//# sourceMappingURL=IconSearch.js.map
